import { useTranslate } from "@similarweb/i18n-provider";
import { LegendWithOneLineBulletFlex } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import type { IChartDataItem } from "../widget/donut-metric/types";

import { Column } from "./Column";
import { DomainLegendItem } from "./DomainLegendItem";

const OthersLegendItem = ({ item }: { item: IChartDataItem }) => (
    <LegendWithOneLineBulletFlex
        text={<Text fontVariant="body2">{item.name}</Text>}
        labelColor={item.color}
        dataAutomation="others-legend-item"
    />
);

export const DomainColumn = ({ item }: { item: IChartDataItem }) => {
    const { translate } = useTranslate();

    return (
        <Column
            fontVariant={item.isPrimary ? "subtitle2" : "caption"}
            textAlign="left"
        >
            {item.isOthers ? (
                <OthersLegendItem item={item} />
            ) : (
                <DomainLegendItem
                    item={item}
                    showTrophy={!!item.isMaxValue}
                    dataAutomation={item.isPrimary ? "primary-domain-legend-item" : "competitor-domain-legend-item"}
                >
                    {item.isPrimary
                        ? translate("activation.common.your-domain", { domain: item.name })
                        : item.name}
                </DomainLegendItem>
            )}
        </Column>
    );
};
